import { addAdvertisement, addAttendance, addBilling, addBooking, addCart, addChild, addClient, addGeneralMaster, addInventory, addMedia, addMembership, addOrder, addPackage, addParent, addProduct, addRole, addSeat, addStaff, addUnit, addUser, addVendor, deleteAdvertisement, deleteAttendance, deleteBilling, deleteCart, deleteChild, deleteClient, deleteFile, deleteGeneralMaster, deleteInventory, deleteMedia, deleteMembership, deleteOrder, deletePackage, deleteParent, deleteProduct, deleteRole, deleteSeat, deleteStaff, deleteUnit, deleteUser, deleteVendor, graphql, login, MembershipBulkUpload, ParentBulkUpload, ProductBulkUpload, searchAdvertisement, searchAttendance, searchBilling, searchBooking, searchCart, searchChild, searchClient, searchFiles, searchGeneralMaster, searchInventory, searchMedia, searchMembership, searchOrder, searchPackage, searchParent, searchProduct, searchRole, searchSeat, searchSpecialists, searchStaff, searchUnit, searchUser, searchVendor, sendOtp, StaffBulkUpload, updateAdvertisement, updateAttendance, updateBilling, updateChild, updateClient, updateGeneralMaster, updateInventory, updateMedia, updateMembership, updateOrder, updatePackage, updateParent, updateProduct, updateRole, updateSeat, updateStaff, updateUnit, updateUser, updateVendor, uploadSingle, verifyOtp } from "../redux/Reducers/RoleAndPermissionReducer/Endpoints";
import { getElevateUser } from "../storage/Storage";

export const brandOptions = [
    { value: "loreal", label: "L'Oréal" },
    { value: "olaplex", label: "Olaplex" },
    { value: "redken", label: "Redken" },
    { value: "schwarzkopf", label: "Schwarzkopf" },
    { value: "wella", label: "Wella" },
    { value: "matrix", label: "Matrix" },
    { value: "paul-mitchell", label: "Paul Mitchell" },
    { value: "kerastase", label: "Kérastase" },
    { value: "tigi", label: "TIGI" },
    { value: "moroccan-oil", label: "Moroccan Oil" },
    { value: "other", label: "Other" }
];

export const productTypeOptions = [
    { value: "hair-care", label: "Hair Care" },
    { value: "skin-care", label: "Skin Care" },
    { value: "makeup", label: "Makeup" },
    { value: "nail-care", label: "Nail Care" },
    { value: "body-care", label: "Body Care" },
    { value: "tools-equipment", label: "Tools & Equipment" },
    { value: "accessories", label: "Accessories" }
];



export const vendorOptions = [
    { value: "vendor1", label: "Beauty Supply Co." },
    { value: "vendor2", label: "Professional Products Ltd." },
    { value: "vendor3", label: "Salon Distributors Inc." },
    { value: "vendor4", label: "Premium Beauty Suppliers" },
    { value: "vendor5", label: "Elite Salon Products" }
];

export const businessTypeOptions = [
    { value: "retail", label: "Retail" },
    { value: "professional", label: "Professional" },
    { value: "both", label: "Both" }
];

export const paymentMethod = [
    { label: 'CASH', value: 'CASH' },
    { label: 'UPI', value: 'UPI' },
    { label: 'WALLET', value: 'WALLET' },
    { label: 'CARD', value: 'CARD' }
]

export const expenseCategory = [
    { label: 'Water Bottels', value: 'water bottels' },
    { label: 'Soft Drinks', value: 'soft drinks' },
    { label: 'Salon Products', value: 'salon products' },
    { label: 'Cleaning', value: 'cleaning' },
    { label: 'Labour', value: 'labour' },
    { label: 'Rooms Mirror', value: 'rooms mirror' },
    { label: 'Mukul Cosmetics', value: 'mukul cosmetics' }
]

export const expiryOptions = [
    { value: '1 Year', label: '1 Year' },
    { value: '6 Months', label: '6 Months' },
    { value: '3 Months', label: '3 Months' },
    { value: '1 Month', label: '1 Month' }
];


export const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" }
];

export const sectionOptions = [
    { value: "1", label: "Section1" },
    { value: "2", label: "Section2" },
    { value: "3", label: "Section3" },
    { value: "4", label: "Section4" },
    { value: "5", label: "Section5" },
    { value: "6", label: "Section6" },
    { value: "7", label: "Section7" },
    { value: "8", label: "Section8" },
    { value: "9", label: "Section9" },
    { value: "10", label: "Section10" },
];

export const designationOptions = [
    { value: "manager", label: "Manager" },
    { value: "hair_dresser", label: "Hair Dresser" },
    { value: "senior_stylist", label: "Senior Stylist" },
    { value: "junior_stylist", label: "Junior Stylist" },
    { value: "beautician", label: "Beautician" },
    { value: "makeup_artist", label: "Makeup Artist" },
    { value: "nail_technician", label: "Nail Technician" },
    { value: "spa_therapist", label: "Spa Therapist" },
    { value: "receptionist", label: "Receptionist" },
    { value: "helper", label: "Helper" },
];


export const taskIntervalOptions = [
    { value: "09:00-09:30", label: "9:00 AM - 9:30 AM" },
    { value: "09:30-10:00", label: "9:30 AM - 10:00 AM" },
    { value: "10:00-10:30", label: "10:00 AM - 10:30 AM" },
    { value: "10:30-11:00", label: "10:30 AM - 11:00 AM" },
    { value: "11:00-11:30", label: "11:00 AM - 11:30 AM" },
    { value: "11:30-12:00", label: "11:30 AM - 12:00 PM" },
    { value: "12:00-12:30", label: "12:00 PM - 12:30 PM" },
    { value: "12:30-13:00", label: "12:30 PM - 1:00 PM" },
    { value: "13:00-13:30", label: "1:00 PM - 1:30 PM" },
    { value: "13:30-14:00", label: "1:30 PM - 2:00 PM" },
    { value: "14:00-14:30", label: "2:00 PM - 2:30 PM" },
    { value: "14:30-15:00", label: "2:30 PM - 3:00 PM" },
    { value: "15:00-15:30", label: "3:00 PM - 3:30 PM" },
    { value: "15:30-16:00", label: "3:30 PM - 4:00 PM" },
    { value: "16:00-16:30", label: "4:00 PM - 4:30 PM" },
    { value: "16:30-17:00", label: "4:30 PM - 5:00 PM" },
    { value: "17:00-17:30", label: "5:00 PM - 5:30 PM" },
    { value: "17:30-18:00", label: "5:30 PM - 6:00 PM" },
    { value: "18:00-18:30", label: "6:00 PM - 6:30 PM" },
    { value: "18:30-19:00", label: "6:30 PM - 7:00 PM" },
    { value: "19:00-19:30", label: "7:00 PM - 7:30 PM" },
    { value: "19:30-20:00", label: "7:30 PM - 8:00 PM" },
    { value: "20:00-20:30", label: "8:00 PM - 8:30 PM" },
    { value: "20:30-21:00", label: "8:30 PM - 9:00 PM" },
    { value: "21:00-21:30", label: "9:00 PM - 9:30 PM" },
    { value: "21:30-22:00", label: "9:30 PM - 10:00 PM" }
];

export const weekOff = [
    { value: "sunday", label: "Sunday" },
    { value: "monday", label: "Monday" },
    { value: "tuesday", label: "Tuesday" },
    { value: "wednesday", label: "Wednesday" },
    { value: "thursday", label: "Thursday" },
    { value: "friday", label: "Friday" },
    { value: "saturday", label: "Saturday" }
];

export const workingHours = [
    { value: "8", label: "8 Hours" },
    { value: "9", label: "9 Hours" },
    { value: "10", label: "10 Hours" },
    { value: "12", label: "12 Hours" }
];
export const customerTypeOptions = [
    { value: "Walk In", label: "Walk In" },
    { value: "Non Walk In", label: "Non Walk In" },

];

export const typeOptions = [
    { value: "Employee", label: "Employee" },
    { value: "Admin", label: "Admin" },
    { value: "Manager", label: "Manager" }
];

export const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" }
];

export const followupStatusOptions = [
    { value: "active", label: "Active" },
    { value: "closed", label: "Closed" }
];
export const seatStatusOptions = [
    { value: "available", label: "Available" },
    { value: "occupied", label: "Occupied" },
    { value: "maintenance", label: "Maintenance" },
];

export const ageGroupOptions = [
    { value: "Child (0-12)", label: "Child (0-12)" },
    { value: "Teen (13-17)", label: "Teen (13-17)" },
    { value: "Young Adult (18-25)", label: "Young Adult (18-25)" },
    { value: "Adult (26-54)", label: "Adult (26-54)" },
    { value: "Senior (55+)", label: "Senior (55+)" },
]

export const priorityOptions = [
    { value: 'low', label: '🟢 Low Priority' },
    { value: 'medium', label: '🟡 Medium Priority' },
    { value: 'high', label: '🔴 High Priority' },
];

export const taskFrequencyOptions = [
    { value: 'once', label: 'One Time Only', description: 'Task will run only once on specific date & time' },
    { value: 'daily', label: 'Daily', description: 'Task will repeat every day' },
    { value: 'weekly', label: 'Weekly', description: 'Task will repeat on selected days of week' },
    { value: 'monthly', label: 'Monthly', description: 'Task will repeat on selected weeks of month' }
];

export const weekDaysOptions = [
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' },
    { value: 6, label: 'Saturday' },
    { value: 7, label: 'Sunday' }
];

export const monthWeeksOptions = [
    { value: 1, label: 'First Week' },
    { value: 2, label: 'Second Week' },
    { value: 3, label: 'Third Week' },
    { value: 4, label: 'Fourth Week' },
    { value: 5, label: 'Last Week of Month' },
];


// Unit options for the dropdown
export const unitOptions = [
    // Volume Units
    { value: "L", label: "Liter (L)" },
    { value: "ml", label: "Milliliter (ml)" },
    { value: "gal", label: "Gallon (gal)" },
    { value: "fl_oz", label: "Fluid Ounce (fl oz)" },

    // Weight Units
    { value: "kg", label: "Kilogram (kg)" },
    { value: "g", label: "Gram (g)" },
    { value: "lb", label: "Pound (lb)" },
    { value: "oz", label: "Ounce (oz)" },
    { value: "mg", label: "Milligram (mg)" },

    // Length Units
    { value: "m", label: "Meter (m)" },
    { value: "cm", label: "Centimeter (cm)" },
    { value: "mm", label: "Millimeter (mm)" },
    { value: "in", label: "Inch (in)" },
    { value: "ft", label: "Foot (ft)" },
    { value: "yd", label: "Yard (yd)" },

    // Area Units
    { value: "m2", label: "Square Meter (m²)" },
    { value: "ft2", label: "Square Foot (ft²)" },

    // Count Units
    { value: "pcs", label: "Piece (pcs)" },
    { value: "dz", label: "Dozen (dz)" },
    { value: "pack", label: "Pack" },
    { value: "box", label: "Box" },
    { value: "bottle", label: "Bottle" },
    { value: "tube", label: "Tube" },
    { value: "jar", label: "Jar" },
    { value: "can", label: "Can" },
    { value: "bag", label: "Bag" },
    { value: "spray", label: "Spray" },
    { value: "pump", label: "Pump" },

    // Service Units
    { value: "hr", label: "Hour (hr)" },
    { value: "min", label: "Minute (min)" },
    { value: "session", label: "Session" },
    { value: "time", label: "Time" }
];



export const stateOptions = [
    { value: "andhra-pradesh", label: "Andhra Pradesh" },
    { value: "arunachal-pradesh", label: "Arunachal Pradesh" },
    { value: "assam", label: "Assam" },
    { value: "bihar", label: "Bihar" },
    { value: "chhattisgarh", label: "Chhattisgarh" },
    { value: "goa", label: "Goa" },
    { value: "gujarat", label: "Gujarat" },
    { value: "haryana", label: "Haryana" },
    { value: "himachal-pradesh", label: "Himachal Pradesh" },
    { value: "jharkhand", label: "Jharkhand" },
    { value: "karnataka", label: "Karnataka" },
    { value: "kerala", label: "Kerala" },
    { value: "madhya-pradesh", label: "Madhya Pradesh" },
    { value: "maharashtra", label: "Maharashtra" },
    { value: "manipur", label: "Manipur" },
    { value: "meghalaya", label: "Meghalaya" },
    { value: "mizoram", label: "Mizoram" },
    { value: "nagaland", label: "Nagaland" },
    { value: "odisha", label: "Odisha" },
    { value: "punjab", label: "Punjab" },
    { value: "rajasthan", label: "Rajasthan" },
    { value: "sikkim", label: "Sikkim" },
    { value: "tamil-nadu", label: "Tamil Nadu" },
    { value: "telangana", label: "Telangana" },
    { value: "tripura", label: "Tripura" },
    { value: "uttar-pradesh", label: "Uttar Pradesh" },
    { value: "uttarakhand", label: "Uttarakhand" },
    { value: "west-bengal", label: "West Bengal" },
    // Union Territories
    { value: "andaman-nicobar", label: "Andaman and Nicobar Islands" },
    { value: "chandigarh", label: "Chandigarh" },
    { value: "dadra-nagar-haveli-daman-diu", label: "Dadra and Nagar Haveli and Daman and Diu" },
    { value: "delhi", label: "Delhi" },
    { value: "jammu-kashmir", label: "Jammu and Kashmir" },
    { value: "ladakh", label: "Ladakh" },
    { value: "lakshadweep", label: "Lakshadweep" },
    { value: "puducherry", label: "Puducherry" }
];





export const deviceTypeOptions = [
    { value: "Mobile", label: "Mobile" },
    { value: "Television", label: "Television" },
    { value: "Screen", label: "Screen" },
    { value: "Billboard", label: "Billboard" },
]

// Horizontal/Landscape Resolutions
export const horizontalResolutions = [
    { value: "1280x720", label: "1280x720 (HD)" },
    { value: "1366x768", label: "1366x768 (WXGA)" },
    { value: "1600x900", label: "1600x900 (HD+)" },
    { value: "1920x1080", label: "1920x1080 (Full HD)" },
    { value: "2560x1440", label: "2560x1440 (QHD)" },
    { value: "3840x2160", label: "3840x2160 (4K UHD)" },
    { value: "4096x2160", label: "4096x2160 (Cinema 4K)" },
    { value: "1280x1000", label: "1280x1000 (Custom)" },
]

// Vertical/Portrait Resolutions
export const verticalResolutions = [
    { value: "720x1280", label: "720x1280 (HD Portrait)" },
    { value: "768x1366", label: "768x1366 (WXGA Portrait)" },
    { value: "828x1792", label: "828x1792 (iPhone 11/XR)" },
    { value: "900x1600", label: "900x1600 (HD+ Portrait)" },
    { value: "1080x1920", label: "1080x1920 (Full HD Portrait)" },
    { value: "1080x2400", label: "1080x2400 (Mobile Portrait)" },
    { value: "1170x2532", label: "1170x2532 (iPhone 12/13/14)" },
    { value: "1179x2556", label: "1179x2556 (iPhone 15/16)" },
    { value: "1206x2622", label: "1206x2622 (iPhone 16 Pro)" },
    { value: "1284x2778", label: "1284x2778 (iPhone 12/13/14 Pro Max)" },
    { value: "1290x2796", label: "1290x2796 (iPhone 15/16 Plus)" },
    { value: "1320x2868", label: "1320x2868 (iPhone 16 Pro Max)" },
    { value: "1440x2560", label: "1440x2560 (QHD Portrait)" },
    { value: "2160x3840", label: "2160x3840 (4K Portrait)" },
    { value: "2000x3000", label: "2000x3000 (Custom Portrait)" },
]

// Orientation options
export const orientationOptions = [
    { value: "horizontal", label: "Horizontal" },
    { value: "vertical", label: "Vertical" },
]





export const userTypeOptions = [
    { value: "SuperAdmin", label: "Super Admin", },
    { value: "Admin", label: "Admin" },
    { value: "Manager", label: "Manager" },
    { value: "Staff", label: "Staff" }
];

export const roleTypeOptions = [
    { value: "SuperAdmin", label: "Super Admin", },
    { value: "Admin", label: "Admin" },
    { value: "Manager", label: "Manager" },
    { value: "Staff", label: "Staff" }
];

export const checkType = [
    { value: "SuperAdmin", label: "Super Admin", dropdownValue: ["Admin", "Manager", "Staff"] },
    { value: "Admin", label: "Admin", dropdownValue: ["Manager", "Staff"] },
    { value: "Manager", label: "Manager", dropdownValue: ["Staff"] },
]

export const CheckDropdownValue = () => {
    const loginRoleType = getElevateUser()?.roleData?.roleType;
    console.log("loginRoleType", loginRoleType);
    const dropdownRoles = checkType.find(
        (item) => item.value.toLowerCase() === loginRoleType?.toLowerCase()
    )?.dropdownValue || [];

    return dropdownRoles.map(role => ({ label: role, value: role }));
};

// export const getUserType = () => {
//     let loginUserType = getElevateUser()?.userType;
//     const position = userTypeOptions.findIndex(obj => obj.value === loginUserType);

//     if (position === -1) return [];

//     return userTypeOptions.slice(position);
// }

export const getUserType = () => {
    const loginUserType = getElevateUser()?.userType;
    console.log("loginUserType", loginUserType);

    const position = userTypeOptions.findIndex(obj => obj.value === loginUserType);

    // Agar userType list me nahi mila ya wo sabse niche ka role hai
    if (position === -1 || position === userTypeOptions.length - 1) return [];

    // Niche wale roles return karo
    return userTypeOptions.slice(position + 1);
};


export const SeperAdmiinPermission = () =>

    [
        {
            value: "dashboard",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchBilling, searchRole, searchGeneralMaster] },
                    write: { allowed: true, url: [searchBilling, searchRole, searchGeneralMaster] },
                    delete: { allowed: true, url: [searchBilling, searchRole, searchGeneralMaster] },
                }
            ],
            child: []
        },
        {
            value: "quicksale",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchUser, searchRole, searchUnit, searchGeneralMaster, searchProduct, searchClient, updateClient, addBilling, updateBilling, searchChild, searchParent, searchMembership, searchPackage] },
                    write: { allowed: true, url: [searchRole, searchUnit, searchGeneralMaster, searchBilling, searchClient] },
                    delete: { allowed: true, url: [searchRole, searchUnit, searchGeneralMaster, searchBilling, searchClient] },
                }
            ],
            child: []
        },
        {
            value: "bills",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchRole, searchUnit, searchGeneralMaster, searchBilling, searchClient] },
                    write: { allowed: true, url: [searchRole, searchUnit, searchGeneralMaster, searchBilling, searchClient] },
                    delete: { allowed: true, url: [searchRole, searchUnit, searchGeneralMaster, searchBilling, searchClient] },
                }
            ],
            child: []
        },
        {
            value: "user",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchUser, searchRole, searchUnit] },
                    write: { allowed: true, url: [addUser, updateUser, searchGeneralMaster, uploadSingle] },
                    delete: { allowed: true, url: [deleteUser] },
                }
            ],
            child: []
        },
        {
            value: "client",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchClient, searchRole, searchUnit] },
                    write: { allowed: true, url: [addClient, updateClient, searchGeneralMaster, uploadSingle] },
                    delete: { allowed: true, url: [deleteClient] },
                }
            ],
            child: []
        },
        {
            value: "unit",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchUnit, searchRole] },
                    write: { allowed: true, url: [addUnit, updateUnit, searchGeneralMaster, uploadSingle] },
                    delete: { allowed: true, url: [deleteUnit] },
                }
            ],
            child: []
        },
        {
            value: "vendor",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchVendor, searchRole, searchUnit] },
                    write: { allowed: true, url: [addVendor, updateVendor, searchGeneralMaster, uploadSingle] },
                    delete: { allowed: true, url: [deleteVendor] },
                }
            ],
            child: []
        },

        {
            value: "seat",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchSeat, searchRole, searchUnit] },
                    write: { allowed: true, url: [addSeat, updateSeat, graphql, searchGeneralMaster, uploadSingle] },
                    delete: { allowed: true, url: [deleteSeat] },
                }
            ],
            child: []
        },
        // {
        //     value: "attendance",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchAttendance] },
        //             write: { allowed: true, url: [addAttendance, updateAttendance, searchGeneralMaster, uploadSingle] },
        //             delete: { allowed: true, url: [deleteAttendance] },
        //         }
        //     ],
        //     child: []
        // },
        {
            value: "inventory",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchInventory, searchOrder, searchRole, searchUnit, searchGeneralMaster] },
                    write: { allowed: true, url: [addInventory, addOrder, updateOrder, updateInventory, uploadSingle] },
                    delete: { allowed: true, url: [deleteOrder, deleteInventory] },
                }
            ],
            child: []
        },
        {
            value: "rolesAndPermissions",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchRole, searchUnit] },
                    write: { allowed: true, url: [addRole, updateRole] },
                    delete: { allowed: true, url: [deleteRole] },
                }
            ],
            child: []
        },
        {
            value: "product",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchProduct, searchRole, searchUnit] },
                    write: { allowed: true, url: [addProduct, updateProduct, ProductBulkUpload, uploadSingle, searchGeneralMaster, uploadSingle] },
                    delete: { allowed: true, url: [deleteProduct] },
                }
            ],
            child: []
        },
        // {
        //     value: "packages",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchPackage] },
        //             write: { allowed: true, url: [addPackage, updatePackage] },
        //             delete: { allowed: true, url: [deletePackage] },
        //         }
        //     ],
        //     child: []
        // },
        {
            value: "staff",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchAttendance, addAttendance, updateAttendance, searchUnit, searchRole, searchGeneralMaster] },
                    write: { allowed: true, url: [searchAttendance, addAttendance, updateAttendance,] },
                    delete: { allowed: true, url: [deleteAttendance] },
                }
            ],
            child: []
        },

        // {
        //     value: "membership",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchMembership] },
        //             write: { allowed: true, url: [addMembership, updateMembership, MembershipBulkUpload] },
        //             delete: { allowed: true, url: [deleteMembership] },
        //         }
        //     ],
        //     child: []
        // },
        {
            value: "services",
            url: [],
            permission: [
                {
                    read: { allowed: true, url: [searchParent, searchChild, searchRole, searchUnit] },
                    write: { allowed: true, url: [addParent, updateParent, ParentBulkUpload, addChild, updateChild, searchGeneralMaster, searchUser, uploadSingle, searchProduct] },
                    delete: { allowed: true, url: [deleteParent, deleteChild] },
                }
            ],
            child: []
        },

        // {
        //     value: "services",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true },
        //             write: { allowed: true },
        //             delete: { allowed: true },
        //         }
        //     ],
        //     child: [
        //         {
        //             value: "parent",
        //             url: [],
        //             permission: [
        //                 {
        //                     read: { allowed: true, url: [searchParent] },
        //                     write: { allowed: true, url: [addParent, updateParent, ParentBulkUpload] },
        //                     delete: { allowed: true, url: [deleteParent] },
        //                 }
        //             ]
        //         },
        //         {
        //             value: "child",
        //             url: [],
        //             permission: [
        //                 {
        //                     read: { allowed: true, url: [searchChild] },
        //                     write: { allowed: true, url: [addChild, updateChild] },
        //                     delete: { allowed: true, url: [deleteChild] },
        //                 }
        //             ]
        //         }
        //     ]
        // },
        // {
        //     value: "generalMaster",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchGeneralMaster] },
        //             write: { allowed: true, url: [addGeneralMaster, updateGeneralMaster] },
        //             delete: { allowed: true, url: [deleteGeneralMaster] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "cart",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchCart] },
        //             write: { allowed: true, url: [addCart] },
        //             delete: { allowed: true, url: [deleteCart] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "booking",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchBooking] },
        //             write: { allowed: true, url: [addBooking] },
        //             delete: { allowed: true, url: [] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "advertisement",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchAdvertisement, searchMedia] },
        //             write: { allowed: true, url: [addAdvertisement, addMedia, updateAdvertisement, updateMedia] },
        //             delete: { allowed: true, url: [deleteAdvertisement, deleteMedia] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "media",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchMedia] },
        //             write: { allowed: true, url: [addMedia, updateMedia] },
        //             delete: { allowed: true, url: [deleteMedia] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "fileManagement",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchFiles] },
        //             write: { allowed: true, url: [uploadSingle] },
        //             delete: { allowed: true, url: [deleteFile] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "specialists",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchSpecialists] },
        //             write: { allowed: true, url: [] },
        //             delete: { allowed: true, url: [] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "authentication",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [] },
        //             write: { allowed: true, url: [login, sendOtp, verifyOtp] },
        //             delete: { allowed: true, url: [] },
        //         }
        //     ],
        //     child: []
        // },
        // {
        //     value: "billing",
        //     url: [],
        //     permission: [
        //         {
        //             read: { allowed: true, url: [searchBilling] },
        //             write: { allowed: true, url: [addBilling, updateBilling] },
        //             delete: { allowed: true, url: [deleteBilling] },
        //         }
        //     ],
        //     child: []
        // }

    ];

//dd
export const dashboardOptions = [
    { value: 'today', label: 'Today' },
    { value: 'currentWeek', label: 'Weekly' },
    { value: 'currentMonth', label: 'Monthly' },
    { value: 'hourly', label: 'Hourly' },
];

export const duration = [
    { label: "Days", value: "days" },
    { label: "Months", value: "months" },
    { label: "Years", value: "years" }
]

export const discountTypeOptions = [
    { label: 'Percentage Discount', value: 'percentage' },
    { label: 'Fixed Amount Discount', value: 'fixed' }
];

// Applicable on options
export const applicableOnOptions = [
    { label: 'Both Products & Services', value: 'both' },
    { label: 'Services Only', value: 'service' },
    { label: 'Products Only', value: 'product' }
];